import { createAction } from "store/actions";
import { VIDEO_MODAL } from "./consts";

export const videoModalOpen = () => createAction(VIDEO_MODAL.open);
export const videoModalClose = () => createAction(VIDEO_MODAL.close);
